var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2521_8997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3815 5.14964C18.3713 4.60966 18.3615 4.09956 18.3615 3.60607C18.3615 3.21945 18.0481 2.90602 17.6614 2.90602C14.6675 2.90602 12.3881 2.04561 10.488 0.19822C10.2162 -0.0661198 9.7837 -0.0660265 9.51199 0.19822C7.61214 2.04561 5.33305 2.90602 2.33935 2.90602C1.95274 2.90602 1.6393 3.21945 1.6393 3.60607C1.6393 4.09965 1.62959 4.60994 1.61923 5.15001C1.52328 10.1751 1.39186 17.0571 9.77073 19.9614C9.84503 19.9872 9.9225 20.0001 9.99997 20.0001C10.0774 20.0001 10.155 19.9872 10.2292 19.9614C18.6087 17.057 18.4775 10.1748 18.3815 5.14964ZM10.0001 18.5571C2.81408 15.9467 2.92273 10.2282 3.01915 5.1767C3.02494 4.87354 3.03054 4.5797 3.03446 4.29165C5.8384 4.1733 8.08061 3.32362 10.0001 1.65153C11.9197 3.32362 14.1623 4.17339 16.9664 4.29165C16.9703 4.57961 16.9759 4.87326 16.9817 5.17624C17.078 10.2279 17.1866 15.9466 10.0001 18.5571Z",
    fill: "#99A4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 7.56828L9.03137 10.9469L7.58954 9.50509C7.31615 9.23179 6.87288 9.23179 6.59958 9.50509C6.32618 9.77858 6.32618 10.2218 6.59958 10.4951L8.53638 12.432C8.67303 12.5686 8.85225 12.6369 9.03137 12.6369C9.21049 12.6369 9.3897 12.5686 9.52635 12.432L13.4001 8.55834C13.6735 8.28495 13.6735 7.84167 13.4002 7.56837C13.1269 7.29498 12.6836 7.29489 12.4102 7.56828Z",
    fill: "#99A4A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2521_8997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.9ba5cec05aae9a232df3494a4fe440c7.svg";
export { ForwardRef as ReactComponent };